import styled from 'styled-components';
import LoaderImage from '../../assets/images/loader.gif';

export const Wrapper = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;

  .loader {
    width: 40px;
    height: 40px;
    background: #fff url(${LoaderImage});
    background-size: cover;
    border: 5px solid #fff;
    border-radius: 5px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Loading/styles.js